module.exports = __webpack_public_path__ + "img/main-back.png";